import { defineStore, storeToRefs } from "pinia";
import { checkAuthentication, checkAuthenticationOAuth,checkAuthenticationLaravel } from '@/../../EshJSLib/services/auth';
import { makeUserLogout } from '@/../../EshJSLib/services/logoutUser';
import { patientStore } from "@/store/patient";
import { getMenuService } from '@/../../EshJSLib/services/menuService';
import { MenuItemsModel } from '@/../../EshJSLib/models/MenuItemsModel';
import { menuItemStore } from '@/store/menu';
import router from '../router'
export const authStore = defineStore("authStore", {
    state: () => ({
        token: null,
        user: null,
        expires_at:null,
    }),
    getters: {
        getToken: (state) => state.token,
        getUser: (state) => state.user
    },
    actions: {
        authorizeUser: async function (userDetails) {
            const response = await checkAuthentication(userDetails);
            
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('menu')
            localStorage.removeItem('patientdetails')
            
            this.token = response?.success?.token || null
            this.user = response?.success?.user.id_utente || null
            this.expires_at = response?.success?.expires_at|| null
            localStorage.setItem('token', response?.success?.token)
            localStorage.setItem('expires_at', response?.success?.expires_at)
           
            localStorage.setItem('user', response?.success?.user.id_utente)
            console.log("rst ax : " +  response?.success?.token )
            console.log("rst tkn : " + localStorage.getItem('token') )
          
            return response
        },
        authorizeUserOAuth: async function (userDetails) {
            const response = await checkAuthenticationOAuth(userDetails);
            this.token = response?.success?.token || null
            this.user = response?.success?.user.id_utente || null
            this.expires_at = response?.success?.expires_at|| null
        
            localStorage.setItem('token', response?.success?.token)
            localStorage.setItem('user', response?.success?.user.id_utente)
            localStorage.setItem('expires_at', response?.success?.expires_at)
        
            return response
        },
        refreshState: async function (token, userDetails) {
            this.token = token

            this.user = userDetails
            const store = patientStore();
            const patient = storeToRefs(store);

            const menuLoader = menuItemStore();
            if (menuLoader.getMenuItems) {

                
                await menuLoader.fetchMenuItems(this.user);
                await store.getPatientDetails(this.user);
            

            }
        },
        logoutUser: async function () {
          
            sessionStorage.$reset;
            menuItemStore.$reset
            this.$reset;
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('menu')
            localStorage.removeItem('patientdetails')
            localStorage.setItem('patient', null);
            router.push({name: 'Login'})
        }
    },
});